import { render, staticRenderFns } from "./Timetable.vue?vue&type=template&id=2ed2159b"
import script from "./Timetable.vue?vue&type=script&lang=js"
export * from "./Timetable.vue?vue&type=script&lang=js"
import style0 from "./Timetable.vue?vue&type=style&index=0&id=2ed2159b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports